import withPhones from '../../hoc/withPhones';
import PhoneList from './PhoneList';

export default withPhones(PhoneList);
